export const replaceAll = (str, de, para) => { 
    var pos = str.indexOf(de);
    while (pos > -1) {
        str = str.replace(de, para);
        pos = str.indexOf(de);
    }
    return (str);
}

export const lpad = (target, padString, length) => {
    target = target;
    while (target.length < length)
        target = padString + target;
    return target;
}

export const capitalize = (str) => {    
    if (str && typeof str === "string") {
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    } else {
        return '';
    }
};

export const getFirstAndLastName = (fullName) => {
    if(!fullName){
        return ""
    }
    let nameArray = fullName.split(" ");
  let name = (nameArray.length > 1) ? (nameArray[0] + " " + nameArray[nameArray.length - 1]) : nameArray[0];
    return name;
}

export const getFirstName = (fullName) => {
    if(!fullName){
        return ""
    }
    let nameArray = fullName.split(" ");
    return (nameArray.length > 1) ? nameArray[0] : '';    
}

export const capitalizeFirst = (str) => {
    if (str) {    
        return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
    } else {
        return '';
    }
};

export const sanitize = (str) => {
    if (str) { 
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
    } else {
        return '';
    }
}

export const removeEspecialChar = str => {
    return str.replace(/[^a-z0-9]/gi,'')
}

export const isJson = (item) => {
    if (typeof item !== "string") {
      try {
        item = JSON.stringify(item);
      } catch {
        return false;
      }
    }
    
    try {
        JSON.parse(item);
      return true;
    } catch (e){
      return false;
    }
  }
  
export const formataEspecieBeneficio = (especie) => {
  if (!especie) return "";

  const specialWords = {
    contribuicao: "Contribuição",
    pensao: "Pensão",
    previdenciaria: "Previdenciária",
    bpc: "BPC",
    loas: "LOAS",
  };

  const exceptions = new Set(["de", "a", "do", "com", "por"]);

  const especieFormatada = especie
    .toLowerCase()
    .split(" ")
    .map((word) => specialWords[word] || (!exceptions.has(word) ? word[0].toUpperCase() + word.slice(1) : word));

  return especieFormatada.join(" ");
};
